import {
  InternalLayoutProvider,
  SubHomeLayout,
} from 'volto-ministerio-publico-federal/components/Layouts';
import { RenderBlocksWithoutTitle } from 'volto-ministerio-publico-federal/components/View/InternalView/RenderBlocksWithoutTitle';
import { SubHomeBanner } from './SubHomeBanner';
import { type SubHomeViewProps } from './types';

/**
 * View do layout `subhome_view` — a Sub-home (Minihome).
 *
 * Ao contrário da capa (`CapaView`), cujo esqueleto de faixas é fixo em
 * código, aqui a página é montada pelo editor de blocos comum: a ordem, a
 * presença e o conteúdo de cada faixa saem de `blocks`/`blocks_layout` do
 * próprio conteúdo. Esta view só troca a moldura (sem cabeçalho de página) e
 * o "chrome" das faixas — quem faz os blocos parecerem cartões é o
 * `.mpf-subhome` de `pages/_subhome-view.scss`.
 *
 * O `InternalLayoutProvider` é o mesmo da página interna porque a sidebar de
 * slot (`asideLeftSlot`: navegação de contexto, Serviços em Destaque,
 * Área responsável) e os `relatedItems` nativos funcionam aqui sem
 * nenhuma adaptação — é o terceiro quadro do Figma.
 */
const SubHomeView = ({ content }: SubHomeViewProps) => {
  const { title, description, relatedItems, largura_total } = content || {};

  return (
    <InternalLayoutProvider
      title={title}
      description={description}
      relatedItems={relatedItems}
      larguraTotal={largura_total}
    >
      <SubHomeLayout>
        {/* Antes dos blocos, e fora deles: a faixa do topo vem da "Imagem de
            destaque" do próprio conteúdo, não de algo que o editor monta. Sem
            o campo preenchido não renderiza nada, e a página abre no primeiro
            bloco. */}
        <SubHomeBanner content={content} />
        <RenderBlocksWithoutTitle content={content} />
      </SubHomeLayout>
    </InternalLayoutProvider>
  );
};

export default SubHomeView;
